import { Controller } from '@hotwired/stimulus'

export class IngredientFormController extends Controller {
  static targets = ['searchStage', 'detailsStage']

  onIngredientSelected () {
    if (this.hasDetailsStageTarget) {
      this.detailsStageTarget.style.gridTemplateRows = '1fr'
    }
  }

  cancel () {
    this.element.style.transition = 'opacity 150ms ease-out'
    this.element.style.opacity = '0'
    this.element.addEventListener('transitionend', () => this.element.remove(), { once: true })
    setTimeout(() => { if (this.element.parentNode) this.element.remove() }, 300)
  }

  closeOnEscape (event) {
    if (event.key === 'Escape') {
      event.preventDefault()
      const cancelBtn = this.element.querySelector(
        '[data-action*="ingredient-form#cancel"], [data-cancel-edit]'
      )
      if (cancelBtn) cancelBtn.click()
    }
  }

  saveOnCmdEnter (event) {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }
}
